import { Injectable } from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,GaugeResponseObject } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Subscription,timer } from "rxjs";



@Injectable()
export class EMLPObjectValueProvider implements DataProvider {

    widget: Widget;
    config: any;
    valueAPIUrl = '/api/values/';
    propertyAPIUrl = '/api/properties/'
    pointName = "";
    private timer;
    private subscription: Subscription;
    private widgetDrawn: boolean = false;
    private defaultInterval = 30;
    private dpName: string = "";

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private logger: LogService,
        private dashboardConfig: DashboardConfigManager) {

    }
 
   //this is to get reduced COV data if required
    getReducedCovData(tData:any){
        
    }
    getData(w: Widget) {
        this.widget = w;
        this.config = this.widget.getConfig();
        try {
            if (this.config == undefined) {
                this.logger.logWarning("EMLPObjectValueProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.GetObjectValue();
                        }
                    }, error => {
                        //this code will get executed when base URL path is inccorrect
                        this.logger.logWarning("EMLPObjectValueProvider", "EMLPObjectValueProvider can not login to desigo cc.");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.GetObjectValue();
            } else {
                this.logger.logWarning("EMLPObjectValueProvider", "EMLPObjectValueProvider can not login to desigo cc.");
                this.widget.Draw(null);
            }



        }
        catch (error) {
            this.logger.logError('EMLPObjectValueProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

    // this will zoom the widget
    zoom(zoomFrom: any, zoomTo: any) {
    }


    private StartTimer(widget: Widget) {
        let interval = 1;
        if (this.config.pollingInterval != undefined)
            interval = this.config.pollingInterval;
        else
            interval = this.defaultInterval;

        var timerintervale = interval * 1000;
        this.timer = timer(timerintervale, timerintervale);
        this.subscription = this.timer.subscribe((t:HttpResponse<any>) => this.callback(widget));
    }

    callback(widget: Widget) {
        this.getData(widget);
    }

    private GetObjectValue() {

        if (this.config.pointName) {
            this.pointName = this.config.pointName;
            if (this.pointName == "") {
                this.widget.Draw(null);
                throw new Error("Invalid point name in URL.");
            }
        }

        let baseUrl = this.dashboardConfig.getBaseUrl();
        let systemName = this.pointName.split(':')[0];
        let point = this.pointName.split(':')[1];
        let systemId = 0;
        let points: any[] = [];
        let valueUrl: string = baseUrl + this.valueAPIUrl + point +"?readMaxAge=-1";
        let propertyUrl: string = baseUrl + this.propertyAPIUrl + point;
        let counterType = this.config.counterType;

        //get token
        let token: any = this.authService.getToken();// window.sessionStorage.getItem("_token");
        let headers: HttpHeaders = new HttpHeaders({"Accept": "application/json","Access-Control-Allow-Origin": "*","Authorization": "Bearer " + token});
        // headers.append("Accept", "application/json");
        // headers.append("Access-Control-Allow-Origin", "*");
        // headers.append("Authorization", "Bearer " + token);
        this.logger.logInfo("EMLPObjectValueProvider", "Calling WSI API");
        this.http.get(valueUrl, {
            headers: headers
        }).subscribe({next:(res:HttpResponse<any>) => {
            this.logger.logInfo("EMLPObjectValueProvider", "Received response." + res);
            try {
                if (res.status < 200 || res.status >= 300) {
                    this.widget.Draw(null);
                    throw new Error("Bad response status: " + res.status);
                }
                this.http.get(propertyUrl, { headers: headers }).subscribe((propResp:HttpResponse<any>) => {
                    if (propResp.status < 200 || propResp.status >= 300) {
                        this.widget.Draw(null);
                        throw new Error("Bad response status: " + propResp.status);
                    }
                    let result1: any = res;//.json();
                    let propertyResponse: any = propResp;//.json();
                    //create data collection
                    if (result1 && result1[0].Value && propertyResponse && propertyResponse[0].Properties[0] != null) {
                        var value = result1[0].Value;
                        var property = propResp[0].Properties[0];                        
                        let resolutionvalue : any;
                        resolutionvalue = (value.Value != null && value.Value != undefined) ? parseFloat(value.Value).toFixed(property.Resolution):undefined;
                        var responseObject: GaugeResponseObject =
                            {
                                ObjectId: (propertyResponse[0].ObjectId) ?
                                propertyResponse[0].ObjectId : result1[0].ObjectId ? result1[0].ObjectId : undefined,

                                PropertyName: (property.PropertyName) ?
                                    property.PropertyName : undefined,

                                Value: resolutionvalue ,

                                DisplayValue: resolutionvalue ,

                                Unit: (property.UnitDescriptor != null && property.UnitDescriptor != undefined) ?
                                    property.UnitDescriptor : undefined,

                                QualityGood: value.QualityGood,

                                DataPointName: property.Descriptor ? property.Descriptor : undefined,
                                IsMultiState: this.checkIfMultistate(value)
                            };
                        this.logger.logInfo("EMLPObjectValueProvider", "Call for drawing widget is initiated");

                        if (!this.widgetDrawn) {
                            systemId = this.dashboardConfig.hasSystemData && (this.dashboardConfig.systemData.find(x => x.Name === systemName)) ? (this.dashboardConfig.systemData.find(x => x.Name === systemName)).Id : systemId;
                            points.push(this.pointName);
                            //let requestOptions = new RequestOptions({ headers: headers });
                            let descriptorUrl = this.dashboardConfig.getBaseUrl() + "/api/systembrowser/" + systemId;
                            this.http.post(descriptorUrl, points, { headers: headers }).subscribe((result:HttpResponse<any>) => { // to get data point descriptor and name
                                let system:any  = result;//.json();
                                let deviceDescriptor = system && system.length > 0 && system[0].Nodes.length > 0 ? system[0].Nodes.find(x=>x.Designation.includes(".Powermanager."))?system[0].Nodes.find(x=>x.Designation.includes(".Powermanager.")).Descriptor:null : null;
                                let showDeviceDescription = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor ? this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor : undefined;
                                let showPropertyDescriptor = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor ? this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor : undefined;
                                this.dpName = showPropertyDescriptor && showDeviceDescription ? deviceDescriptor + " [" + responseObject.DataPointName + "]" : showDeviceDescription ? deviceDescriptor : responseObject.DataPointName;
                                responseObject.DataPointName = this.dpName;
                                this.widget.Draw(responseObject);
                                this.widgetDrawn = true;
                                this.StartTimer(this.widget);
                            }, error => {
                                this.logger.logError("EMLPObjectValueProvider", error);
                            })
                        }
                        else
                            this.widget.Update(responseObject);
                    }
                    else {
                        this.logger.logError("EMLPObjectValueProvider", "Error while processing response for point name: " + this.pointName);
                        this.widget.Draw(null);
                    }
                })
            }
            catch (error) {
                this.logger.logError("EMLPObjectValueProvider", "Error in response : " + error);
            }
        }, error:(error) => {
            //TODO:
            // this section of code was part of processError() method
            //because widget and loggerhelper are losing their references , moving code to inline method
            //this needs more investigation and code refactor
            let errMsg: any = (error && error.message) ? error.message : "Server error";
            if (this.logger)
                this.logger.logError("EMLPObjectValueProvider", "Error in received from service: " + errMsg);
            if (this.widget)
                this.widget.Draw(null);
        }});


    }
    private checkIfMultistate(property: any): boolean {
        return property.Type === "ExtendedEnum" ? true : false;
    }
    private processError(error: any) {
        let errMsg: any = error.message || "Server error";

        if (this.logger)
            this.logger.logError("EMLPObjectValueProvider", errMsg);

        if (this.widget)
            this.widget.Draw(null);
    }
    public ngOnDestroy(): void {
        this.dispose();
    }


    dispose(): void {
        try {
            if (this.subscription)
                this.subscription.unsubscribe();
            if (this.logger)
                this.logger.logInfo("EMLPObjectValueProvider", "EMLPObjectValueProvider disposed");
        }
        catch (error) {
            if (this.logger)
                this.logger.logError("EMLPObjectValueProvider", "error while dispoing EMLPObjectValueProvider, " + error);
        }

    }



}



